"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTable = exports.FileItemContextMenuItemTemplates = void 0;
const React = __importStar(require("react"));
const react_table_1 = require("react-table");
const resources_1 = require("../model/resources");
const row_select_on_click_1 = require("./table-plugins/row-select-on-click");
const resource_icon_1 = require("./table-plugins/resource-icon");
const sort_on_header_click_1 = require("./table-plugins/sort-on-header-click");
const context_menu_1 = require("./table-plugins/context-menu");
const utilities_1 = require("./table-plugins/utilities");
const react_dnd_1 = require("react-dnd");
const react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
const row_dnd_1 = require("./table-plugins/row-dnd");
const editable_cell_1 = require("./table-plugins/editable-cell");
const utilities_2 = require("../utilities");
const binary_modal_1 = require("./binary-modal");
const file_browser_css_1 = require("./table-plugins/file-browser-css");
const flex_layout_fixed_width_1 = require("./table-plugins/flex-layout-fixed-width");
const portal_context_menu_1 = require("./portal-context-menu");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const table_keyboard_select_all_1 = require("./table-plugins/table-keyboard-select-all");
const scrollable_table_body_1 = require("./table-plugins/scrollable-table-body");
exports.FileItemContextMenuItemTemplates = {
    Select: { Icon: free_solid_svg_icons_1.faCheck },
    Open: { Icon: free_solid_svg_icons_1.faFolderOpen },
    Rename: { Icon: free_solid_svg_icons_1.faEdit },
    Delete: {
        Icon: free_solid_svg_icons_1.faTrash,
        ClassName: "menu-item-danger",
        RequireConfirmation: {
            Title: "Permanently delete item(s)?",
            Question: "This action cannot be undone."
        }
    },
    Archive: { Icon: free_solid_svg_icons_1.faArchive },
    Move: { Icon: free_solid_svg_icons_1.faArrowAltCircleRight, DisplayName: "Move to..." },
    Copy: { Icon: free_solid_svg_icons_1.faCopy, DisplayName: "Copy to..." },
    Restore: { Icon: free_solid_svg_icons_1.faArrowAltCircleUp },
    NewFolder: { Icon: free_solid_svg_icons_1.faFolderPlus, DisplayName: "New Folder" },
    Download: { Icon: free_solid_svg_icons_1.faFileDownload, DisplayName: "Download" },
    Upload: { Icon: free_solid_svg_icons_1.faUpload, DisplayName: "Upload" }
};
function FileTable({ Items, Submit, OpenFolder, OnSelectionChanged, Reload, PromptForFolder, Context, RaiseAlert, CreateNewFolder, PendingRenameResource, CancelRename, style }) {
    const [tableId] = React.useState(utilities_2.MakePseudoRandomUuidv4());
    const data = React.useMemo(() => Items
        .map(item => ({
        Name: item.Path.Name,
        LastModified: item.Type === resources_1.ResourceTypes.Forecast || item.Type === resources_1.ResourceTypes.ResourceFile ? item.LastModifiedAt : new Date(0),
        Resource: item,
        FileType: item.Type === resources_1.ResourceTypes.Folder ? "" : item.FileType
    }))
        .sort(DefaultFileItemSort), [Items]);
    const executeWithAlert = (action) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield action();
        }
        catch (error) {
            RaiseAlert(`${error}`);
        }
    });
    const nameColumnHeader = "Name";
    const getColumns = (firstItem) => {
        const columns = [
            {
                Header: () => null,
                id: "Icon",
                accessor: "Resource",
                maxWidth: 30,
                Cell: ({ cell }) => React.createElement("div", { className: "file-item-icon-cell" }, resource_icon_1.RenderResourceIcon(cell.value))
            },
            {
                Header: nameColumnHeader,
                accessor: "Name",
                // Allow in-place rename for resources which support it (via useSingleEditableCell)
                GetUpdater: (row) => row.original.Resource.Rename
                    ? (newName) => __awaiter(this, void 0, void 0, function* () {
                        yield executeWithAlert(() => row.original.Resource.Rename(newName));
                        yield Reload();
                    })
                    : null
            },
            {
                Header: "Last modified",
                accessor: "LastModified",
                sortType: "datetime",
                Cell: ({ cell }) => React.createElement(TooltipSpan, { value: cell.value.valueOf() ? FormatDateTime(cell.value) : "\u00A0" /* Need to use nbsp for span to fill the column */ })
            },
            {
                Header: "Type",
                accessor: "FileType"
            }
        ];
        if (firstItem && firstItem.Resource.Archived) {
            columns.push({
                id: "OriginalLocation",
                Header: "Original location",
                accessor: "Resource",
                Cell: ({ cell }) => React.createElement(TooltipSpan, { value: cell.value.Archived ? cell.value.Archived.From.Value : "" })
            });
            columns.push({
                id: "ArchivedAt",
                Header: "Archived at",
                accessor: "Resource",
                Cell: ({ cell }) => React.createElement(TooltipSpan, { value: cell.value.Archived ? FormatDateTime(cell.value.Archived.At) : "" })
            });
        }
        return columns;
    };
    const columns = React.useMemo(() => getColumns(data[0]), [data[0]]);
    const onRowDrop = (droppedRows, target) => __awaiter(this, void 0, void 0, function* () {
        if (target.original.Resource.Type === resources_1.ResourceTypes.Folder && target.original.Resource.Move) {
            yield target.original.Resource.Move(droppedRows.map(row => row.original.Resource));
            yield Reload();
        }
    });
    const GetRowContextMenuItems = function* GetRowActions(row, instance) {
        const resource = row.original.Resource;
        // Single-item-only actions
        if (!utilities_1.IsRowSelectTableInstance(instance)
            || instance.selectedFlatRows.length == 0
            || (instance.selectedFlatRows.length == 1 && instance.selectedFlatRows[0].id === row.id)) {
            if (ResourceIsSelectableInContext(resource, Context)) {
                yield {
                    Key: "Select",
                    Action: () => Submit(resource),
                    SeparatorAfter: true,
                    Emphasize: true
                };
            }
            if (resource.Type === resources_1.ResourceTypes.Folder) {
                yield {
                    Key: "Open",
                    Action: () => OpenFolder(resource)
                };
            }
            if (editable_cell_1.IsSingleEditableCellTableInstance(instance)) {
                const nameColumn = instance.columns.find(column => column.Header === nameColumnHeader);
                if (nameColumn) {
                    yield {
                        Key: "Rename",
                        Action: () => instance.StartEditingCell({ row: row.id, column: nameColumn.id })
                    };
                }
                else {
                    console.warn(`Cannot find '${nameColumnHeader}' to begin editing`);
                }
            }
        }
        // Multi-item actions, allow if one or more selected items supports it
        const selectedItems = (utilities_1.IsRowSelectTableInstance(instance) && instance.selectedFlatRows.length
            ? instance.selectedFlatRows
            : [row]).map(selectedRow => selectedRow.original.Resource);
        const multiItemActions = ["Delete", "Archive", "Restore"];
        for (const actionName of multiItemActions) {
            const itemActions = selectedItems.map(item => item[actionName])
                .filter(action => !!action);
            if (itemActions.length) {
                const executeAll = () => __awaiter(this, void 0, void 0, function* () {
                    const promises = itemActions.map(a => a ? a() : Promise.resolve());
                    yield executeWithAlert(() => __awaiter(this, void 0, void 0, function* () { yield Promise.all(promises); }));
                    Reload();
                });
                yield {
                    Key: actionName,
                    Action: executeAll
                };
            }
        }
        if (resource.Type !== resources_1.ResourceTypes.Folder) {
            yield {
                Key: "Download",
                Action: () => __awaiter(this, void 0, void 0, function* () { return window.open(yield resource.GetDownloadUrl(), "_blank"); })
            };
        }
        // Bulk insert operations with folder prompt
        const insertActions = [
            ["Move", "Move"],
            ["InsertCopy", "Copy"]
        ];
        for (const [actionName, menuItem] of insertActions) {
            yield {
                Key: menuItem,
                Action: () => __awaiter(this, void 0, void 0, function* () {
                    const target = yield PromptForFolder(selectedItems, selectedItems[0].Path.Parent // Convoluted way to initialise folder UI at the current folder
                    );
                    if (target && target[actionName]) {
                        yield executeWithAlert(() => __awaiter(this, void 0, void 0, function* () {
                            yield InsertItemsWithOverwriteConfirmation(target, selectedItems, actionName);
                            OpenFolder(target); // Navigate to target folder after successful operation
                        }));
                    }
                })
            };
        }
        yield {
            Key: "NewFolder",
            Action: CreateNewFolder,
            SeparatorBefore: true
        };
    };
    const options = {
        columns,
        data,
        getRowId: item => `${tableId}/${item.Resource.Id}`,
        getContextMenuItems: function* (row, instance) {
            for (const item of FilterRowContextMenu([...GetRowContextMenuItems(row, instance)], Context)) {
                if (item.SeparatorBefore) {
                    yield portal_context_menu_1.FileItemMenuItem("Separator");
                }
                const props = Object.assign(Object.assign({}, exports.FileItemContextMenuItemTemplates[item.Key]), { Name: item.Key, Action: item.Action, Emphasize: item.Emphasize });
                yield portal_context_menu_1.FileItemMenuItem(props); // react-contextmenu doesn't apply css classes correctly if this is invoked via JSX instead of function call :(
                if (item.SeparatorAfter) {
                    yield portal_context_menu_1.FileItemMenuItem("Separator");
                }
            }
        },
        selectionMode: "MultiWithCtrlShift",
        onRowDblClick: item => Submit(item.Resource),
        getRowDndProps: (row, table) => {
            // Disallow drag while an element is being edited https://dev.azure.com/oxecon/Models/_workitems/edit/6184
            const allowDrag = editable_cell_1.IsSingleEditableCellTableInstance(table) && !!table.ActiveCell
                ? false
                : { type: "file-item" };
            return {
                isDraggable: allowDrag,
                isDropTarget: row.original.Resource.Type === resources_1.ResourceTypes.Folder && row.original.Resource.Move
                    ? { acceptType: "file-item", onDrop: onRowDrop }
                    : false
            };
        },
        editCell: PendingRenameResource ? { RowId: `${tableId}/${PendingRenameResource.Id}`, ColumnName: "Name" } : undefined,
        cancelEdit: CancelRename
    };
    const tableInstance = react_table_1.useTable(options, react_table_1.useSortBy, sort_on_header_click_1.useSortOnHeaderClick, react_table_1.useRowSelect, row_select_on_click_1.useRowSelectOnClick, table_keyboard_select_all_1.useTableKeyboardSelectAllInstance, file_browser_css_1.useFileBrowserCss, editable_cell_1.useSingleEditableCell, context_menu_1.useRowContextMenu, row_dnd_1.useRowDnd, flex_layout_fixed_width_1.useFlexLayoutWithFixedWidthSupport, scrollable_table_body_1.useScrollableTableBody);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;
    const selectedItems = utilities_1.IsRowSelectTableInstance(tableInstance)
        ? tableInstance.selectedFlatRows.map(row => row.original.Resource)
        : [];
    const selectionHash = selectedItems.map(item => item.Path.Value).join("|");
    React.useEffect(() => {
        OnSelectionChanged(selectedItems);
    }, [selectionHash]);
    return React.createElement(React.Fragment, null,
        React.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
            React.createElement("div", Object.assign({}, utilities_1.AddStyles(getTableProps(), style || {})),
                headerGroups.map(headerGroup => (
                // Apply the header row props
                React.createElement("div", Object.assign({}, headerGroup.getHeaderGroupProps()), // Loop over the headers in each row
                headerGroup.headers.map(column => (
                // Apply the header cell props
                React.createElement("div", Object.assign({}, column.getHeaderProps()), // Render the header
                column.render('Header'))))))),
                React.createElement("div", Object.assign({}, getTableBodyProps()), // Loop over the table rows
                rows.map(row => {
                    // Prepare the row for display
                    prepareRow(row);
                    return React.createElement(row_dnd_1.DndRow, { row: row, instance: tableInstance, key: row.id });
                })))));
}
exports.FileTable = FileTable;
function TooltipSpan({ value }) {
    return React.createElement("span", { title: value }, value);
}
function FormatDateTime(date) {
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
}
function FilterRowContextMenu(menuItems, uiContext) {
    // Remove editing actions when showing move UI
    if (uiContext.Type === "MoveToFolder") {
        const permittedItems = ["Select", "Open"];
        return menuItems.filter(menuItem => permittedItems.includes(menuItem.Key));
    }
    else {
        return menuItems;
    }
}
function DefaultFileItemSort(a, b) {
    const sortDimensions = [
        resource => resource.Type === resources_1.ResourceTypes.Folder ? 0 : 1,
        resource => resource.Path.Name
    ];
    for (const dimension of sortDimensions) {
        const [aDim, bDim] = [a, b].map(item => dimension(item.Resource));
        if (aDim < bDim) {
            return -1;
        }
        else if (bDim < aDim) {
            return 1;
        }
    }
    return 0;
}
function InsertItemsWithOverwriteConfirmation(target, items, operationName) {
    return __awaiter(this, void 0, void 0, function* () {
        const operation = target[operationName];
        if (!operation) {
            return false;
        }
        if (items.some(item => item.Path.Parent.Equals(target.Path))) {
            throw new Error(`Cannot move or copy item to its own containing folder`);
        }
        const existingItems = yield target.GetChildren();
        const existingItemsByName = new Map(existingItems.map(existingItem => [existingItem.Path.Name.toLowerCase(), existingItem]));
        const conflicts = items
            .map(item => existingItemsByName.get(item.Path.Name.toLowerCase()))
            .filter(item => !!item);
        if (conflicts.length) {
            const overwrite = yield binary_modal_1.PromptForBinaryChoice({
                Title: `Overwrite ${utilities_2.Pluralize(conflicts, "item")}?`,
                Question: `${utilities_2.Pluralize(conflicts, "item")} will be overwritten, are you sure?`,
                YesText: "Overwrite",
                NoText: "Cancel",
                Dimensions: { Width: 300 }
            });
            if (overwrite) {
                yield Promise.all(conflicts.map(existingItem => existingItem && existingItem.Delete ? existingItem.Delete() : {}));
            }
            else {
                return false;
            }
        }
        yield operation(items);
        return true;
    });
}
function ResourceIsSelectableInContext(resource, context) {
    switch (resource.Type) {
        case resources_1.ResourceTypes.Folder:
            return context.Type === "OpenFolder";
        case resources_1.ResourceTypes.Forecast:
        case resources_1.ResourceTypes.ResourceFile:
            return context.Type === "OpenFile";
        default:
            return utilities_2.AssertNever(resource, "ResourceType");
    }
}
//# sourceMappingURL=file-table.js.map